// extracted by mini-css-extract-plugin
export default {"bpk-visually-hidden":"BpkVisuallyHidden_bpk-visually-hidden__Y2IxN"};